
const initBookmarkPage = () => {
  const bookmarkModule = document.querySelector('.bookmark-page');
  const closeBtn = document.getElementById('close-bookmark');

  if (localStorage.getItem('bookmarkClosed') === 'true') {
    if (bookmarkModule) {
      bookmarkModule.remove();
    }
    return;
  }

  if (closeBtn && bookmarkModule) {
    closeBtn.addEventListener('click', () => {
      bookmarkModule.remove();

      localStorage.setItem('bookmarkClosed', 'true');
    });
  }
};

export default initBookmarkPage;
